/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from "react";
import { Dropdown } from "office-ui-fabric-react";
import FormikErrorMessage from "../FormikErrorMessage/FormikErrorMessage";

/**
 * OfficeUI dropdown for use in Formik forms.
 * @param {field} field property.
 * @param {styles} component styles.
 * @returns {React.ReactElement} formik Dropdown component.
 */
const FormikDropdown = (props: any): React.ReactElement => {
  const { field } = props;

  return (
    <div>
      <Dropdown
        selectedKey={field.value}
        onChange={[field.onChange]}
        options={[props.options]}
        styles={props.styles}
        {...field}
        {...props}
      />
      <FormikErrorMessage name={field.name} />
    </div>
  );
};

export default FormikDropdown;
